export const SITE_URL = "https://swisstools.dev";
export const SITE_NAME = "Swisstools";
export const OG_IMAGE_PATH = "/icon.png";

export interface RouteMeta {
  title: string;
  description: string;
}

export const DEFAULT_META: RouteMeta = {
  title: "Swisstools — the boring side of shipping, sorted",
  description:
    "A developer toolkit for the unglamorous parts of shipping: release notes, feature flags, API mocks, and a webhook inbox. Free for every team in beta.",
};

export const ROUTE_META: Record<string, RouteMeta> = {
  "/": {
    title: "Swisstools — the boring side of shipping, sorted",
    description:
      "Release notes stakeholders read, feature flags PMs can toggle, mocked endpoints in fifteen seconds, and a webhook inbox that's a delight to debug. Free in beta.",
  },
  "/releases": {
    title: "Release Notes Your CEO Will Actually Read — Swisstools",
    description:
      "Point Swisstools at your GitHub repo and we draft the release — one note, multiple framings for customers, CS, execs, and engineers. You edit, we deliver to email and Slack.",
  },
  "/flags": {
    title: "Feature Flags PMs Can Flip, Devs Can Trust — Swisstools",
    description:
      "Folder-organized, typed feature flags with per-customer overrides. Flip them without a deploy and read them over a plain HTTP REST API — no client SDK required.",
  },
  "/mocks": {
    title: "API Mocks: A Real URL, Real-Shaped JSON in 15 Seconds — Swisstools",
    description:
      "Paste a JSON schema and get a real mock endpoint with realistic latency, CORS, and status codes. First-class 404 and 500 variants for unblocking frontend work fast.",
  },
  "/webhooks": {
    title: "Webhook Inbox: Every Payload Inspectable, Replayable — Swisstools",
    description:
      "Capture webhooks from Stripe, GitHub, Linear, Shopify, or anything custom. Inspect the full body, headers, and signature, then replay to localhost, staging, or a teammate.",
  },
};

export function metaForPath(pathname: string): {
  meta: RouteMeta;
  indexable: boolean;
} {
  const normalized =
    pathname.length > 1 && pathname.endsWith("/")
      ? pathname.slice(0, -1)
      : pathname;
  const match = ROUTE_META[normalized];
  if (match) return { meta: match, indexable: true };
  return { meta: DEFAULT_META, indexable: false };
}

export function canonicalUrl(pathname: string): string {
  if (pathname === "/") return SITE_URL;
  return `${SITE_URL}${pathname}`;
}
